module.exports = __webpack_public_path__ + "static/media/LogoEN.2097e9d9.svg";